module.exports = __webpack_public_path__ + "static/media/logo.950a0ff7.png";